import React from "react";

// design
const CARD= { borderRadius: "8px", marginTop: "16px", boxShadow: "0 2px 6px rgba(0,0,0,0.10)" };
const HDR= { background: "#374151", padding: "8px 14px", display: "flex", alignItems: "center", gap: "8px", borderRadius: "8px 8px 0 0" };
const TITLE = { margin: 0, color: "white", fontSize: "13px", fontWeight: "600" };
const SECTION= { borderLeft: "1px solid #cbd5e1", borderRight: "1px solid #cbd5e1" };
const FOOTER= { ...SECTION, borderBottom: "1px solid #cbd5e1", borderRadius: "0 0 8px 8px", padding: "5px 14px 6px", background: "#f9fafb", borderTop: "1px solid #e5e7eb", fontSize: "10px", color: "#6b7280", display: "flex", gap: "10px", flexWrap: "wrap", alignItems: "center" };

export default function DatasetSummary({ data }) {
    // fallback
    if (!data || !data.twoAfcData) return null;

    const matrix = data.twoAfcData.matrix || [];
    const participantChoices = data.twoAfcData.participantChoices || [];
    const M= matrix.length;
    const N = new Set(participantChoices.map(c => c.participantId)).size;
    const total= participantChoices.length;
    const pairs= M * (M - 1) / 2;
    const avgPerPair= pairs > 0 ? (total / pairs).toFixed(1) : "–";
    const avgPerParticipant= N > 0 ? (total / N).toFixed(1) : "–";

    const tiles = [
        { value: M,     label: "Methods",      tip: "Number of methods / conditions compared" },
        { value: N,     label: "Participants",  tip: "Number of observers who completed the experiment" },
        { value: total, label: "Comparisons",   tip: "Total pairwise choices recorded" },
        { value: pairs, label: "Unique Pairs",  tip: `C(${M}, 2) = ${M}×${M-1}/2: distinct method pairs` },
    ];

    const VarRow = ({ label, value }) => (
        <div style={{ display: "flex", alignItems: "baseline", fontSize: "11px", padding: "4px 0", borderBottom: "1px solid #f1f5f9" }}>
            <span style={{ color: "#6b7280", minWidth: "110px", flexShrink: 0 }}>{label}</span>
            <span style={{ color: "#111827", fontWeight: "600", fontFamily: "monospace", fontSize: "11px" }}>{value}</span>
        </div>
    );

    const ComputedRow = ({ label, value, tip }) => (
        <div title={tip} style={{ display: "flex", alignItems: "baseline", fontSize: "11px", padding: "4px 0", borderBottom: "1px solid #f1f5f9", cursor: "help" }}>
            <span style={{ color: "#6b7280", minWidth: "200px", flexShrink: 0 }}>{label}</span>
            <span style={{ color: "#2563eb", fontWeight: "700", fontFamily: "monospace", fontSize: "12px" }}>{value}</span>
        </div>
    );

    return (
        <div style={{ ...CARD, width: "fit-content", minWidth: "380px" }}>

            <div style={HDR}>
                <h4 style={TITLE}>Dataset Summary</h4>
            </div>

            <div style={{ ...SECTION, display: "grid", gridTemplateColumns: `repeat(${tiles.length}, 1fr)`, background: "#e5e7eb", gap: "1px" }}>
                {tiles.map(({ value, label, tip }) => (
                    <div key={label} title={tip} style={{ background: "white", padding: "12px 10px", textAlign: "center", cursor: "help" }}>
                        <div style={{ fontSize: "24px", fontWeight: "700", color: "#1e293b", lineHeight: 1 }}>{value}</div>
                        <div style={{ fontSize: "10px", color: "#6b7280", marginTop: "4px", fontWeight: "500" }}>{label}</div>
                    </div>
                ))}
            </div>

            <div style={{ ...SECTION, padding: "8px 14px 4px", background: "white" }}>
                <ComputedRow
                    label="Avg comparisons per pair"
                    value={avgPerPair}
                    tip={`${total} total / ${pairs} pairs: how many times each pair was compared on average`}
                />
                <ComputedRow
                    label="Avg comparisons per participant"
                    value={avgPerParticipant}
                    tip={`${total} total / ${N} participants`}
                />
            </div>

            <div style={{ ...SECTION, padding: "6px 14px 8px", background: "#f9fafb", borderTop: "1px solid #e5e7eb" }}>
                <div style={{ fontSize: "10px", color: "#6b7280", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.05em", marginBottom: "4px" }}>Variable Mapping</div>
                <VarRow label="Variable A" value={data.variableA} />
                <VarRow label="Variable B" value={data.variableB} />
                <VarRow label="Chosen variable" value={data.chosenVariable} />
            </div>

            <div style={FOOTER}>
                <span>Hover tiles for details</span>
            </div>
        </div>
    );
}
